// extracted by mini-css-extract-plugin
export var gif = "_jv-0";